import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import Vuelidate from 'vuelidate'
import VueRouter from 'vue-router'
import vco from "v-click-outside"
import Scrollspy from 'vue2-scrollspy';
import VueSweetalert2 from 'vue-sweetalert2';
import Toasted from "vue-toasted";
import JwPagination from "jw-vue-pagination";
import "@/design/index.scss";
import moment from 'moment'
import store from '@/state/store'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import CKEditor from 'ckeditor4-vue';
import VueSplit from 'vue-split-panel';
import state, {ability} from './state/store';
import { abilitiesPlugin } from '@casl/vue';
import "animate.css";
import VueZoomer from 'vue-zoomer';
// import Pusher from 'pusher-js';
import interceptor from '@/api/interceptor'
import App from './App.vue';
import i18n from './i18n';
import Modal from '@/components/modals/Modal'

import TenantRouter from './router/index';
import LandingRouter from './router/LandingRouter';


// export var pusher = new Pusher(process.env.VUE_APP_PUSHER_KEY, {
//   cluster: process.env.VUE_APP_PUSHER_CLUSTER
// });

// Vue.use(VTooltip)
Vue.use(VueZoomer)
Vue.use(VueSplit)
Vue.use( CKEditor );
Vue.use(Loading, {
    "is-full-page": false,
    color: 'rgb(20, 80, 144)',
    loader: 'dots',
    width: 130,
    height: 100,
    backgroundColor: '#f1f5fa',
    opacity: 0.5,
    zIndex: 999,
});
Vue.use(VueRouter)
Vue.use(vco)
Vue.use(Scrollspy);
const VueScrollTo = require('vue-scrollto')
Vue.use(VueScrollTo)
Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.use(Vuelidate)
Vue.prototype.moment = moment
Vue.use(require('vue-chartist'))
Vue.use(VueSweetalert2);
Vue.use(Toasted, {
    duration: 3000,
    position: 'top-center'
});
Vue.use(abilitiesPlugin, ability);
// Pusher.logToConsole = true;
Vue.component('apexchart', VueApexCharts)
Vue.component('jw-pagination', JwPagination);
Vue.component('modal', Modal)
// Vue.prototype.$pusher = pusher;

interceptor();

const host = window.location.host;
const parts = host.split('.');
const router = parts.length == 2 ? LandingRouter : TenantRouter;

new Vue({
    router,
    store,
    state,
    i18n,
    render: h => h(App)
}).$mount('#app')